module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/desktop@2x-54f32c2ee3af4f9613755cdfa78c4f6d.webp";